var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:url(#SVGID_6_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2000
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1016.5784,
    y1: 1056.4142,
    x2: 1191.8413,
    y2: 1056.4142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1162.65,1109.22l-114.79-75.4h0l-14.65-9.62l-8.94-5.87l-7.69-5.05l4.83-3.17l7.1-4.67h-0.1l2.77-1.82 l7.75,5.09l8.94,5.87l14.65,9.62l64.57,42.42c-2.66-8.61-4.88-17.36-6.65-26.21l-41.29-27.13l11.93-7.84h-0.1l2.77-1.82 l41.25,27.09C1139.75,1058.34,1149.11,1084.84,1162.65,1109.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.0189,
    y1: 1000.1646,
    x2: 1199.451,
    y2: 1000.1646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M921.02,1106.21c13.54-24.37,22.9-50.88,27.66-78.51l35.13-23.08l6.46-4.25h-0.1l3.42-2.25l0.99-0.65 l3.79-2.49l16.43-10.79l14.65-9.62l10.52-6.91l14.66-9.63l25.33-16.64l5.99-3.93l7.25-4.76l14.65-9.63l44.09-28.96 c-13.54,24.37-22.9,50.88-27.66,78.51l-38.82,25.5l-2.77,1.82h0.1l-11.93,7.84l-16.63,10.92l-14.65-9.62l13.26-8.71h-0.1 l3.42-2.25l0.99-0.65l52.57-34.54c1.77-8.85,3.99-17.61,6.65-26.21l-47.09,30.93l-5.23,3.44l-19.93,13.1h0l-9.24,6.07l-11.97,7.86 l-2.77,1.82h0.1l-7.1,4.67l-4.83,3.17l-4.2,2.76l-40.85,26.84c-1.77,8.85-3.99,17.61-6.65,26.21l42.31-27.8l8.73-5.74l17.28-11.35 l14.65,9.62l-11.36,7.46l-14.65,9.62L921.02,1106.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 892.4396,
    y1: 933.1719,
    x2: 1212.2457,
    y2: 933.1719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M984.67,993.48l-64.57-42.1c-4.76-27.63-14.12-54.14-27.66-78.52l137.87,90.57l-14.65,9.62l-87.65-57.58 c2.66,8.61,4.88,17.36,6.65,26.21l64.57,42.16l-8.2,5.39h0.1L984.67,993.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 989.1189,
    y1: 953.5495,
    x2: 1145.1626,
    y2: 864.0519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1107.56,852.57l-114.79,75.4h0l-14.65,9.62l-8.94,5.87l-7.69,5.05l4.83,3.17l7.1,4.67h-0.1l2.77,1.82 l7.75-5.09l8.94-5.87l14.65-9.62l64.57-42.42c-2.66,8.61-4.88,17.36-6.65,26.21l-41.29,27.13l11.93,7.84h-0.1l2.77,1.82 l41.25-27.09C1084.66,903.46,1094.02,876.95,1107.56,852.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 840.7293,
    y1: 1049.5565,
    x2: 995.488,
    y2: 973.7489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M929.58,968.32l-64.57,42.1c-4.76,27.63-14.12,54.14-27.66,78.52l137.87-90.57l-14.65-9.62l-87.65,57.58 c2.66-8.61,4.88-17.36,6.65-26.21l64.57-42.16l-8.2-5.39h0.1L929.58,968.32z"
  })))), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M551.03,1292.31c-0.17-4.05-0.45-7.56-0.83-10.54c4.52,2.13,8.57,3.63,12.17,4.51 c3.6,0.87,7.06,1.31,10.38,1.31c3.2,0,6.17-0.54,8.91-1.63c2.75-1.09,4.81-2.62,6.2-4.6c1.38-1.98,2.08-4.25,2.08-6.81 c0-1.49-0.23-2.89-0.7-4.19c-0.47-1.3-1.23-2.62-2.27-3.96c-1.04-1.34-2.85-3.15-5.43-5.43c-2.58-2.28-6.23-5.42-10.96-9.43 l-4.73-4.03c-1.79-1.53-3.41-3.06-4.86-4.57c-1.45-1.51-2.66-2.96-3.64-4.35c-0.98-1.38-1.74-2.64-2.27-3.77 c-0.53-1.13-0.95-2.39-1.25-3.77c-0.3-1.38-0.45-2.8-0.45-4.25c0-3.66,1-7.09,3-10.29c2-3.2,5.02-5.75,9.04-7.67 c4.03-1.92,9.34-2.88,15.94-2.88c4.73,0,10.54,0.64,17.45,1.92c0.08,2.74,0.38,6.11,0.89,10.1c-6.52-2.3-12.44-3.45-17.76-3.45 c-3.66,0-6.73,0.6-9.2,1.81c-2.47,1.21-4.35,2.75-5.62,4.64s-1.92,3.83-1.92,5.82c0,1.19,0.17,2.35,0.51,3.48 c0.34,1.13,0.85,2.2,1.53,3.23c0.98,1.49,2.19,2.99,3.64,4.51c1.45,1.51,3.45,3.35,6.01,5.53c0.64,0.51,3.08,2.51,7.32,6.01 c4.24,3.49,7.33,6.2,9.27,8.12c1.94,1.92,3.48,3.7,4.63,5.34c1.15,1.64,2.04,3.41,2.68,5.3c0.64,1.9,0.96,3.95,0.96,6.17 c0,3.41-0.73,6.55-2.2,9.43s-3.58,5.23-6.33,7.06c-2.75,1.83-5.81,3.13-9.17,3.9c-3.37,0.77-6.88,1.15-10.54,1.15 c-2.94,0-5.97-0.22-9.11-0.67C561.29,1294.89,556.83,1293.88,551.03,1292.31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.05,1294.61l1.28-19.55l1.72-40.51l0.57-18.72c-10.43,0.04-19.56,0.23-27.39,0.58 c0.26-3.41,0.4-6.41,0.45-9.01c10.82,0.04,22.49,0.06,35.01,0.06l20.44-0.06h10.86c-0.3,3.78-0.45,6.78-0.45,9.01 c-6.6-0.38-13.91-0.58-21.92-0.58h-5.24l-1.33,28.29l-1.34,39.84v10.66l-6.14-0.13C706.02,1294.48,703.85,1294.52,700.05,1294.61z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M804.34,1294.61l11.63-21.98l29.65-57.96l3.45-7.28l7.42,0.06c2.3,0,4.8-0.02,7.48-0.06l11.05,31.31 l20.44,55.91l-6.07-0.13c-1.15,0-3.43,0.04-6.84,0.13c-1.15-4.09-3.05-10.01-5.71-17.76c-2.66-7.75-4.9-14.04-6.73-18.85h-34.91 l-9.26,19.11l-8.17,17.51l-6.55-0.13C810.14,1294.48,807.85,1294.52,804.34,1294.61z M838.96,1249.56h28.72l-11.87-33.8 L838.96,1249.56z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M960.83,1294.61l11.63-21.98l29.65-57.96l3.45-7.28l7.42,0.06c2.3,0,4.8-0.02,7.48-0.06l11.05,31.31 l20.44,55.91l-6.07-0.13c-1.15,0-3.43,0.04-6.84,0.13c-1.15-4.09-3.05-10.01-5.71-17.76c-2.66-7.75-4.9-14.04-6.73-18.85h-34.91 l-9.26,19.11l-8.17,17.51l-6.55-0.13C966.64,1294.48,964.35,1294.52,960.83,1294.61z M995.46,1249.56h28.72l-11.87-33.8 L995.46,1249.56z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1128.64,1294.61c0.98-10.99,1.81-24.42,2.52-40.29c0.7-15.87,1.14-31.51,1.31-46.94 c2.94,0.04,5.18,0.06,6.72,0.06l5.95-0.06l-2.04,40.48l-1.53,38.18l12.14,0.06c9.03,0,15.39-0.03,19.07-0.1 c3.68-0.06,7.25-0.2,10.7-0.42c-0.26,2.7-0.47,5.71-0.64,9.01c-9.67-0.09-18.21-0.13-25.62-0.13L1128.64,1294.61z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1258.81,1294.61l0.96-14.7l1.34-30.61l0.89-30.16c0.04-1.75,0.06-3.49,0.06-5.24l-0.06-6.52l6.59,0.06 l6.2-0.06c-0.76,10.65-1.34,21.77-1.72,33.36c-0.68,18.57-1.17,36.53-1.47,53.87l-6.01-0.13 C1264.82,1294.48,1262.56,1294.52,1258.81,1294.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1458.6719,
    y1: 1251.1779,
    x2: 1306.2605,
    y2: 1250.7606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1342.26,1294.61c4.98-6.3,11.04-14.23,18.18-23.77c7.14-9.54,12.66-17.13,16.58-22.75l-7.54-12.72 c-1.41-2.3-3.43-5.52-6.07-9.65l-6.39-9.9c-1.58-2.47-3.34-5.28-5.3-8.44c5.5,0.09,11.12,0.13,16.87,0.13 c4.56,0,9.44-0.04,14.63-0.13c1.87,3.71,4.08,7.72,6.61,12.05c2.53,4.32,4.55,8.08,6.04,11.28c1.7-2.94,4.03-6.59,6.97-10.96 c2.94-4.37,5.52-8.49,7.73-12.36c4.52,0.09,9.44,0.13,14.76,0.13c3.45,0,8.35-0.04,14.7-0.13c-3.07,4.39-7.63,10.61-13.67,18.66 c-6.05,8.05-11.78,16-17.19,23.84c6.9,11.76,16.27,26.67,28.12,44.73c-6.73-0.08-11.78-0.13-15.14-0.13 c-5.62,0-11.18,0.04-16.68,0.13c-1.66-3.41-3.99-7.72-7-12.94c-3-5.22-5.61-10.02-7.83-14.41c-1.66,2.98-4.39,7.18-8.18,12.59 c-3.79,5.41-7.14,10.33-10.03,14.76c-6.22-0.08-11.14-0.13-14.76-0.13C1353.66,1294.48,1348.53,1294.52,1342.26,1294.61z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorfile);
export default __webpack_public_path__ + "static/media/Vector file.28661e10887bb51d6c90eb1e83d33e55.svg";
export { ForwardRef as ReactComponent };